// extracted by mini-css-extract-plugin
export default {"news-template":"styles_news-template__N+cdD","news-area":"styles_news-area__D0-Ib","news-body":"styles_news-body__M1ZeP","news-wrap":"styles_news-wrap__+ESGJ"};